import * as React from 'react';
import { useScrollDownButton_unstable } from './useScrollDownButton';
import { renderScrollDownButton_unstable } from './renderScrollDownButton';
import { useScrollDownButtonStyles_unstable } from './useScrollDownButtonStyles.styles';
import type { ScrollDownButtonProps } from './ScrollDownButton.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// ScrollDownButton component - TODO: add more docs
export const ScrollDownButton: ForwardRefComponent<ScrollDownButtonProps> = React.forwardRef((props, ref) => {
  const state = useScrollDownButton_unstable(props, ref);

  useScrollDownButtonStyles_unstable(state);
  return renderScrollDownButton_unstable(state);
});

ScrollDownButton.displayName = 'ScrollDownButton';
